import { useEffect, useMemo } from "react";

import { type RouteAppComponentProps } from "@/router/routes";
import { setPageTitle } from "@/utils/hook";

import { AppUserInactiveView } from "./view";

function _AppUserInactive(props: RouteAppComponentProps) {
  const email = useMemo(() => localStorage.getItem("rememberedEmail"), []);

  useEffect(() => {
    setPageTitle(window)(props.pageName)();
  }, [props.pageName]);
  return <AppUserInactiveView email={email ?? ""} />;
}

const AppUserInactive = _AppUserInactive;

export default AppUserInactive;
